import { idParam, ROLES } from '../../../../../helpers/commons.helpers';

/**
 * Tools route definitions.
 *
 * These routes are lazy-loaded and intended to be used as children of the
 * authenticated layout. Each route exposes a `meta` object with common
 * properties used by navigation guards and permission checks.
 *
 * @typedef {Object} ToolRouteMeta
 * @property {Array<string>} modules - Application module keys related to the route.
 * @property {boolean} requiresAuth - When true the route requires an authenticated session.
 * @property {Array<string>} roles - Array of role identifiers allowed to access the route.
 *
 * @type {Array<import('vue-router').RouteConfig>}
 */
export default [
    {
        path: "/tools/documentation",
        name: "Documentation",
        meta: {
            title: "Documentation",
            modules: ["documentation"],
            requiresAuth: true,
            roles: [ROLES.SUPER_ADMIN]
        },
        component: () =>
            import(
            /* webpackChunkName: "ToolDocumentation" */ "@/modules/tools/modules/documentations/pages/Documentation"
            )
    },
    {
        path: "/tools/documentation/new",
        name: "NewDocument",
        meta: {
            title: "New Document",
            modules: ["documentation"],
            requiresAuth: true,
            roles: [ROLES.SUPER_ADMIN]
        },
        component: () =>
            import(
            /* webpackChunkName: "documentations" */ "@/modules/tools/modules/documentations/pages/NewDocument"
            )
    },
    {
        path: `/tools/documentation/${idParam()}`,
        name: "Document",
        meta: {
            title: "Document",
            modules: ["documentation"],
            requiresAuth: true,
            roles: [ROLES.SUPER_ADMIN]
        },
        component: () =>
            import(
            /* webpackChunkName: "ToolsDocument" */ "@/modules/tools/modules/documentations/pages/Document"
            )
    },
]